import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BirthStonesArray } from "./data";
import "./index.scss";

function BirthStone() {
  useEffect(() => {
    window.scrollTo(0, 0);
    // document.title = "Gemology for Precious Stones | Galaxy Gemological Institute";
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div className="BirthStonePage">
      <Helmet>
        <link rel="canonical" href="https://www.ggilab.com/gemology" />
        <title>
          Explore Gemology at Galaxy Gemological Institute | GGILab
        </title>
        <meta
          name="description"
          content="Uncover the secrets of gemstones and jewelry through the expert knowledge of Galaxy Gemological Institute. Your source for gemology expertise at GGILab."
        />
      </Helmet>
      <div className="BirthStoneSec">
        <div className="container innerBirthStoneSec">
          <div className="titleDiv margintb">
            <h1 className="title" data-aos="fade-left">
              What is Gemology ?{" "}
            </h1>
            <p data-aos="fade-down">
              Gemology is the scientific study of gemstones , which includes the
              following points:
            </p>
            <ul className="List" data-aos="zoom-out-up">
              <div>
                <li data-aos="zoom-out">What constitutes a gem.</li>
                <li data-aos="zoom-out">The terminology of gemstones.</li>
              </div>
              <div>
                <li data-aos="zoom-out">
                  Their physical and optical properties.
                </li>
                <li data-aos="zoom-out">
                  How those properties are used to identify gems.
                </li>
              </div>
            </ul>
            <p data-aos="zoom-in-up">
              It includes subjects such as geology, mineralogy, chemistry,
              crystallography, physics and optics. The most important thing for
              a gem material is to fulfill the requirements to be a gem.
            </p>
          </div>
          <div className="titleDiv">
            {/* <h6 className="small-title" data-aos="zoom-out-up">
							What We Offering
						</h6> */}
            {/* <h2 className="title" data-aos="fade-right">
							Available BirthStone
						</h2> */}
            <p data-aos="zoom-in">
              There are many variations of birthstone according to your birth
              month and day
            </p>
          </div>
          <div className="BirthStoneDiv">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
              {BirthStonesArray.map((birthst) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-xs-12"
                  key={birthst.id}
                  data-aos="fade-left"
                  data-aos-delay={600}
                >
                  <div className="courseDetail">
                    <div className="courseImage">
                      <img
                        alt="birthst"
                        src={birthst.Stone}
                        data-aos="zoom-in"
                        data-aos-delay={800}
                      />
                    </div>
                    <div className="courseIntro">
                      <div>
                        <p className="postOwner" data-aos="zoom-in">
                          {birthst.month}
                        </p>
                        <h2 className="title courseTitle" data-aos="fade-left">
                          {birthst.Name}
                        </h2>
                        <p className="courseText" data-aos="fade-right">
                          {birthst.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BirthStone);
